<script>
import WarningCard from "@/components/_Shared/Warnings/Card";
import Notice from "@/components/_Shared/Notices/Content";
import { mapState } from "vuex";

export default {
  components: {
    WarningCard,
    Notice
  },

  computed: {
    ...mapState("user", ["user", "closedCities"]),
    isVisible() {
      return this.closedCities.length;
    },
    title() {
      return `Querido(a) ${this.user.first_name},`;
    },
    subtitle() {
      return;
    }
  },

  filters: {
    formatCities(cities) {
      if (cities.length === 1) return cities[0];
      let last = cities[cities.length - 1];
      return cities.join(", ").split(", " + last)[0] + " e " + last;
    }
  }
};
</script>

<template>
  <warning-card v-if="isVisible">
    <notice icon="/static/close.svg" :title="title">
      <div>
        Comunicamos através deste que estamos encerrando, por período indefinido, a nossa operação em
        <b>{{closedCities | formatCities}}</b>. A partir de 18/11/19 não é mais possível contratar novas limpezas.
        <b>Mas não se preocupe :),</b> caso você já tenha limpezas agendadas para acontecer além desta data suas limpezas ocorrerão conforme o solicitado.
        <br />
        <p class="mb-0">Esperamos em breve retornar à sua cidade &lt;3</p>
      </div>
    </notice>
  </warning-card>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/ClosedCities.vue